import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import AxiosInstance from "../../helper/AxiosInstance";
function BlogDetails() {
	const { slug } = useParams()
	const [blog, setBlog] = useState({})
	const [categories, setCategories] = useState([])
	const [recenetBlog, setRecenetBlog] = useState([])
	const getData = async () => {
		try {
			const response = await AxiosInstance.get(`/blog/public/blogs?slug=${slug}`);
			if (response.status == 1) {
				setCategories(response.categories)
				setBlog(response.data);
				setRecenetBlog(response.recentBlog)
			} else {
				setBlog({})
			}
		} catch (err) { console.log(err); } finally {
		}
	}
	useEffect(() => { window.scrollTo(0, 0); getData() }, [slug]);


	return (
		<>

			<Helmet>
				<title>Blog | Taskflier | A Trusted Platform for Outsourcing Project </title>
			</Helmet>

			<div class="pricing-section-one pt-100 pb-80  md-mb-80 bg-gray">
				<div class="shapes shape-one"></div>
				<div class="shapes shape-two"></div>
				<div class="shapes shape-three"></div>
				<div class="container">
					<div class="row">
						<div class="col-lg-9 feature-blog-one blogs-details width-lg blog-details-post-v1">
							<div class="post-meta">
								
								 <img src={`${process.env.REACT_APP_API_URI}/tenants/super/blogs/${blog?.image}`} alt="" class="image-meta" />


								<div className="d-flex justify-content-between align-items-center blog-header ">
									<span class=" text-capitalize">{blog.categorie} - ({blog.author})</span>
									<span className="read">{new Date(blog.createdAt).toUTCString().slice(5, 16)}</span>

								</div>



								<h1 class="maintitle text-capitalize">{blog.title}</h1>
								<p className="pb-4 pt-0" dangerouslySetInnerHTML={{ __html: blog?.description || <></> }}>

								</p>
							</div>

							<div class="comment-area" hidden>
								<h3 class="title">2 Comments</h3>
								<div class="single-comment">
									<div class="d-flex">
										<img src="images/blog/media_30.png" alt="" class="user-img" />
										<div class="comment">
											<h6 class="name">Al Hasani</h6>
											<div class="time">13 June, 2018, 7:30pm</div>
											<p>One touch of a red-hot stove is usually all we need to avoid that kind of discomfort in future. The same true we experience </p>
											<button class="reply">Reply</button>
										</div>
									</div>
								</div>
								<div class="single-comment">
									<div class="d-flex">
										<img src="images/blog/media_31.png" alt="" class="user-img" />
										<div class="comment">
											<h6 class="name">Rashed ka.</h6>
											<div class="time">13 June, 2018, 7:30pm</div>
											<p>One touch of a red-hot stove is usually all we need to avoid that kind of discomfort in future. The same true we experience </p>
											<button class="reply">Reply</button>
										</div>
									</div>
								</div>
							</div>

							<div class="comment-form-section" hidden>
								<h3 class="title">Leave A Comment</h3>
								<p><a href="login.html">Sign in</a> to post your comment or singup if you dont have any account.</p>
								<div class="form-style-light">
									<form action="#">
										<div class="row">
											<div class="col-12">
												<div class="input-group-meta mb-35">
													<label>Name</label>
													<input type="text" placeholder="Michel" />
													<span class="placeholder_icon valid-sign"><img src="images/icon/18.svg" alt="" /></span>
												</div>
											</div>
											<div class="col-12">
												<div class="input-group-meta mb-35">
													<label>Your Email</label>
													<input type="email" placeholder="gobapubo@jogi.net" />
													<span class="placeholder_icon valid-sign"><img src="images/icon/18.svg" alt="" /></span>
												</div>
											</div>
											<div class="col-12">
												<div class="input-group-meta lg mb-35">
													<label>Your Message</label>
													<textarea placeholder="Write your message here..."></textarea>
												</div>
											</div>
											<div class="col-12"><button class="theme-btn-one btn-lg">Post Comment</button></div>
										</div>
									</form>
								</div>
							</div>
						</div>
						<div className="col-lg-3">
							<div class="blog-sidebar-one">
								<div class="sidebar-categories mb-50">
									<h4 class="sidebar-title">Categories</h4>

									<ul>
										{
											categories.map((cate) => {
												return (<li className="text-capitalize"><Link to={`/blog/categorie/${cate.slug}`}>{cate.name} <span>({(cate.blogs).toString().padStart(2, '0')})</span></Link></li>)
											})
										}
									</ul>

								</div>
								<div class="sidebar-recent-news mb-50">
									<h4 class="sidebar-title">Recent Blog</h4>
									<ul>
										{
											recenetBlog.map((rec) => {
												return (<li>
													<Link to={`/blog/${rec.slug}`}>
														<span class="title text-capitalize">{rec.title.length > 60 ? rec.title.slice(0, 60) + "..." : rec.title}</span>
														<span class="blogdate">{new Date(rec.createdAt).toUTCString().slice(5, 16)}</span>
													</Link>
												</li>)
											})
										}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="bubble-one"></div>
				<div class="bubble-two"></div>
				<div class="bubble-three"></div>
				<div class="bubble-four"></div>
				<div class="bubble-five"></div>
				<div class="bubble-six"></div>
			</div>
		</>
	);
}

export default BlogDetails;